module.exports = "https://static.im-cdn.com/mjc/storefront/Anchor/static/media/Star.39f7e731.svg";